export default class SoundManagerONP {
    private static btnSoundData = new Audio(require('../../public/assets/onp/sounds/button.mp3')); // path to file
    private static loopBGM = new Audio(require('../../public/assets/onp/sounds/mainsong.mp3')); // path to file
    //private static loopEnding = new Audio(require('../../public/assets/sounds/ending.mp3')); // path to file
    public static btnSound() {
        this.btnSoundData.play();
    }
    public static loadCheck() {
        this.loopBGM.preload = "auto";
        this.btnSoundData.preload = "auto";
    }
    public static playBGM() {
        this.loopBGM.pause();
        //this.loopEnding.pause();
        this.loopBGM.loop = true;
        this.loopBGM.play();
    }
    public static stopBGM() {
        this.loopBGM.pause();
        //this.loopEnding.pause();
        //this.loopBGM.loop = true;
        //this.loopBGM.play();
    }
    public static playEnding() {
        this.loopBGM.pause();
        //this.loopEnding.pause();
        //this.loopEnding.loop = true;
        //this.loopEnding.play();
    }
    public static playOnce(key:string){
        this.soundData[key].play();
    }
    private static soundData: any = {
        
        logo: new Audio(require('../../public/assets/onp/sounds/greenplay.mp3')),

    }
    public static logoSound() {
        this.soundData.logo.play();
    }
    public static randomIntFromInterval(min: number, max: number) { // min and max included 
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
}
